import './index.css';

import * as serviceWorker from './serviceWorker';

import { Redirect, Route, Router, Switch } from "react-router-dom";

import Admin from './layouts/Admin';
import React from 'react';
import ReactDOM from 'react-dom';
import { createBrowserHistory } from "history";

const hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/admin" component={Admin} />
      <Redirect from="/" to="/admin/envInfo" />
    </Switch>
  </Router>,
  document.getElementById('root')
);

serviceWorker.unregister();
